import { render, staticRenderFns } from "./BotaoConfirmacao.vue?vue&type=template&id=3a4098e6"
import script from "./BotaoConfirmacao.vue?vue&type=script&lang=js"
export * from "./BotaoConfirmacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports